import { createSelector, Selector } from '@reduxjs/toolkit'
import { GlobalState } from '../store'
import { EntityType } from '../api'
import { createAllEntitiesSelector } from './entitySelectors'

export const validReferenceRateSelector: Selector<GlobalState, string[]> = createSelector(
  createAllEntitiesSelector(EntityType.REFERENCE_RATE),
  referenceRates => {
    return referenceRates.filter(referenceRate => referenceRate.name !== 'EONIA').map(referenceRate => referenceRate.id)
  }
)
